"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UA = _interopRequireDefault(require("../UA"));

var _scriptHelper = _interopRequireDefault(require("../scriptHelper"));

var _IssJsBridge = _interopRequireDefault(require("../IssJsBridge"));

var _SellerIssJsBridge = _interopRequireDefault(require("../SellerIssJsBridge"));

var _versionHelper = _interopRequireDefault(require("../versionHelper"));

var _urlHelper = _interopRequireDefault(require("../urlHelper"));

var _requestHelper = _interopRequireDefault(require("../requestHelper"));

var _domainHelper = _interopRequireDefault(require("../domainHelper"));

var _jsonHelper = _interopRequireDefault(require("../jsonHelper"));

var _base64Helper = _interopRequireDefault(require("../base64Helper"));

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var cur$Version = _versionHelper["default"].cur$Version;
var deepGet = _jsonHelper["default"].deepGet;
var getTestGatWay = _domainHelper["default"].getTestGatWay;
var requestHandle = _requestHelper["default"].requestHandle;
var getQueryString = _urlHelper["default"].getQueryString;

var defaultToast = function defaultToast(v) {
  console.warn('需要在业务侧把toast行为传进来，默认是系统alert行为');
  alert(v);
};

var loadSDK = function loadSDK(next) {
  var loadScript = _scriptHelper["default"].loadScript;

  if (_UA["default"].env.alipay) {
    if (window.my === undefined) {
      loadScript(CONSTS.ali_SdkUrl, next);
    } else {
      if (next) {
        next();
      }
    }
  }

  if (_UA["default"].env.wxMiniProgram) {
    if (window.wx === undefined) {
      loadScript(CONSTS.wx_SdkUrl_v160, next);
    } else {
      if (next) {
        next();
      }
    }
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    if (window.xhs === undefined) {
      loadScript(CONSTS.redBook_SdkUrl, next);
    } else {
      if (next) {
        next();
      }
    }
  }

  if (_UA["default"].env.douYinMini) {
    if (window.tt === undefined) {
      loadScript(CONSTS.douYin_SdkUrl, next);
    } else {
      if (next) {
        next();
      }
    }
  }

  if (_UA["default"].env.swanApp) {
    if (window.swan === undefined) {
      loadScript(CONSTS.baidu_SdkUrl, next);
    } else {
      if (next) {
        next();
      }
    }
  }

  if (_UA["default"].env.hwquickApp) {
    if (window.qa === undefined) {
      loadScript(CONSTS.hw_webView_SdkUrl, next);
    } else {
      if (next) {
        next();
      }
    }
  }
};

var webSdkInit = function webSdkInit() {
  var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    openWxConfig: false,
    wxDebug: false
  };
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  var loadScript = _scriptHelper["default"].loadScript;
  var wxDebug = configs.wxDebug,
      openWxConfig = configs.openWxConfig;

  if (_UA["default"].env.alipay && !window.my) {
    loadScript(CONSTS.ali_SdkUrl, next);
  }

  if (_UA["default"].env.shanSong_redBookMini && !window.xhs) {
    loadScript(CONSTS.redBook_SdkUrl, next);
  }

  if (_UA["default"].env.alipay && !window.ap) {
    loadScript(CONSTS.ali_jsApi, next);
  }

  if (_UA["default"].env.swanApp && !window.swan) {
    loadScript(CONSTS.baidu_SdkUrl, next);
  }

  if (_UA["default"].env.wxMiniProgram) {
    if (!window.wx) {
      if (location.pathname.includes('/phone/')) {
        loadScript(CONSTS.wx_SdkUrl_v160, function () {
          if (openWxConfig) {
            wxConfigInit(wxDebug);
          }

          next();
        });
      } else {
        loadScript(CONSTS.wx_SdkUrl, function () {
          if (openWxConfig) {
            wxConfigInit(wxDebug);
          }

          next();
        });
      }
    } else {
      if (openWxConfig) {
        wxConfigInit(wxDebug);
      }
    }
  }

  if (_UA["default"].env.douYinMini && !window.tt) {
    loadScript(CONSTS.douYin_SdkUrl, next);
  }

  if (_UA["default"].env.hwquickApp) {
    if (!window.qa) {
      loadScript(CONSTS.hw_webView_SdkUrl, next);
    }
  }
};

var wxConfigInit = function wxConfigInit() {
  var wxDebug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var targetUrl = encodeURI(window.location.href);

  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    var _window = window,
        _location = _window.location;
    targetUrl = encodeURI(_location.origin + _location.pathname + _location.search);
  }

  var params = {
    targetUrl: targetUrl
  };
  var headers = {};
  headers['Content-Type'] = 'application/x-www-form-urlencoded';
  headers.rpcType = 'dubbo';
  headers.resourceKey = 'uapp.WeixinSupportService.getJsConfig';
  requestHandle({
    url: getTestGatWay('/gateway'),
    headers: headers
  }, params).then(function (back) {
    if (back && back.data) {
      wx.config({
        appId: back.data.appId,
        timestamp: back.data.timestamp,
        nonceStr: back.data.nonceString,
        signature: back.data.signature,
        debug: wxDebug === true,
        jsApiList: ['getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'hideMenuItems', 'chooseImage', 'uploadImage', 'downloadImage']
      });
    }
  })["catch"](function (error) {
    console.error(error);
  });
};

var isAndroidUser$6710 = !_UA["default"].env.userApp_hos && _UA["default"].env.shanSong_userApp_android && cur$Version['>=']('6.7.10');
var isAndroidUser$6700 = !_UA["default"].env.userApp_hos && _UA["default"].env.shanSong_userApp_android && cur$Version['>=']('6.7.00');
var isAndroidSeller$4553 = !_UA["default"].env.shopApp_hos && _UA["default"].env.shanSong_sellerApp_android && cur$Version['>=']('4.5.53');
var NATIVE_PROTOCOL = {
  callTel: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://Call' : 'shansong://Call:/',
  indexPage: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://placeOrder' : 'shansong://placeOrder:/',
  coupon: isAndroidUser$6700 || isAndroidSeller$4553 ? 'shansong://Coupon' : 'shansong://Coupon:/',
  orderDetail: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://OrderDetail' : 'shansong://OrderDetail:/',
  URL_COMPLAIN: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://Complain' : 'shansong://Complain:/',
  URL_SHARE_DIRECT: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://DirectShare' : 'shansong://DirectShare:/',
  URL_CLOSE_COUPON_WINDOW: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://CloseCouponWindow' : 'shansong://CloseCouponWindow:/',
  URL_LOGOUT_SUC: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://AccountWrittenOffSuccess' : 'shansong://AccountWrittenOffSuccess:/',
  URL_LOGIN_MOBILE_CHANGE_SUC: isAndroidUser$6710 || isAndroidSeller$4553 ? 'shansong://ModifyPhoneSuccess' : 'shansong://ModifyPhoneSuccess:/',
  fastLogin: isAndroidUser$6710 ? 'shansong://FastLogin' : 'shansong://FastLogin:/',
  certificate: isAndroidUser$6710 ? 'shansong://Certificate' : 'shansong://Certificate:/',
  URL_EVALUETE: isAndroidUser$6710 ? 'shansong://Evaluete' : 'shansong://Evaluete:/',
  URL_FEEDBACK: isAndroidUser$6710 ? 'shansong://FeedBack' : 'shansong://FeedBack:/',
  URL_COMPANY_EXIT: isAndroidUser$6710 ? 'shansong://CompanyExit' : 'shansong://CompanyExit:/',
  URL_CHARGE_SUCC: isAndroidUser$6710 ? 'shansong://ChargeSucc' : 'shansong://ChargeSucc:/',
  SELLER_obtainPicture: isAndroidSeller$4553 ? 'shansong://ObtainPicture' : 'shansong://ObtainPicture:/',
  SELLER_sendHome: isAndroidSeller$4553 ? 'shansong://sendHome' : 'shansong://sendHome:/',
  SELLER_CourierBlackList: isAndroidSeller$4553 ? 'shansong://CourierBlackList' : 'shansong://CourierBlackList:/',
  SELLER_yisong_go: isAndroidSeller$4553 ? 'shansong://yisong/go' : 'shansong://yisong/go:/'
};
var MINI_PROGRAM_ROUTES = {
  index: '/pages/index/index',
  login: '/pages/login-select/index',
  helpBuyIndex: '/package1/pages/help-buy/index',
  blackList: '/package1/pages/courier-blacklist/index',
  orderList: '/pages/order-list/index'
};
var DOUYIN_MINI_PROGRAM_ROUTES = {
  index: '/pages/index/index',
  login: '/pages/login-select/index',
  blackList: '/package1/pages/courier-blacklist/index',
  orderList: '/pages/order-list/index'
};
var ALI_MINI_PROGRAM_ROUTES = {
  index: '/pages/index/index',
  login: '/pages/login-select/login-select',
  blackList: '/package1/pages/courier-blacklist/index',
  orderList: '/pages/orderList/index'
};
var BAIDU_MINI_PROGRAM_ROUTES = {
  index: '/pages/index/index',
  login: '/pages/login-select/login-select',
  blackList: '/pages/courier-blacklist/courier-blacklist',
  orderList: '/pages/order-list/order-list'
};
var CONSTS = {
  downLoadAPPUrl: 'http://m.ishansong.com/activity/download_v2.html',
  wx_SdkUrl: '//cdn.ishansong.com/iss-app/static/vendor/jweixin-1.3.2.js',
  wx_SdkUrl_v160: '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
  ali_SdkUrl: 'https://appx/web-view.min.js',
  ali_jsApi: '//gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js',
  baidu_SdkUrl: 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.4.js',
  douYin_SdkUrl: 'https://lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.3.0.js',
  hw_SdkUrl: 'https://statres.quickapp.cn/quickapp/js/routerinline.min.js',
  hw_webView_SdkUrl: 'https://quickapp/jssdk.webview.min.js',
  redBook_SdkUrl: 'https://cdn.ishansong.com/user-static/js/xiaohongshu-3.8.0.js'
};

var callTel = function callTel(mobile) {
  if (_UA["default"].env.shanSongApp) {
    return "".concat(NATIVE_PROTOCOL.callTel).concat(encodeURIComponent(JSON.stringify({
      mobile: mobile
    })));
  } else {
    return "tel:".concat(mobile);
  }
};

var goIndex = function goIndex() {
  var otherHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    location.href = CONSTS.downLoadAPPUrl;
  };
  var url = MINI_PROGRAM_ROUTES.index;

  if (_UA["default"].env.shanSong_sellerApp) {
    window.location.href = NATIVE_PROTOCOL.indexPage;
    return;
  }

  if (_UA["default"].env.shanSongApp) {
    window.location.href = NATIVE_PROTOCOL.indexPage;
    return;
  }

  if (miniNavigateTo(url)) {
    return;
  }

  if (_UA["default"].env.hwquickApp) {
    window.location.href = 'hap://app/cn.ishansong.quick/pages/index/index';
  }

  if (otherHandle) {
    otherHandle();
  }
};

var redirectToIndex = function redirectToIndex() {
  var otherHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    location.href = CONSTS.downLoadAPPUrl;
  };
  var url = MINI_PROGRAM_ROUTES.index;

  if (_UA["default"].env.shanSong_sellerApp) {
    window.location.href = NATIVE_PROTOCOL.indexPage;
    return;
  }

  if (_UA["default"].env.shanSongApp) {
    window.location.href = NATIVE_PROTOCOL.indexPage;
    return;
  }

  if (miniNavigateTo(url, 'redirectTo')) {
    return;
  }

  if (_UA["default"].env.hwquickApp) {
    window.location.href = 'hap://app/cn.ishansong.quick/pages/index/index';
  }

  if (otherHandle) {
    otherHandle();
  }
};

var miniNavigateTo = function miniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';

  if (_UA["default"].env.wxMiniProgram) {
    wxMiniNavigateTo(url, actionName);
    return true;
  }

  if (_UA["default"].env.swanApp) {
    swanMiniNavigateTo(url, actionName);
    return true;
  }

  if (_UA["default"].env.alipay) {
    aliMiniNavigateTo(url, actionName);
    return true;
  }

  if (_UA["default"].env.douYinMini) {
    douYinMiniNavigateTo(url, actionName);
    return true;
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    redBookMiniNavigateTo(url, actionName);
    return true;
  }

  return false;
};

var swanMiniNavigateTo = function swanMiniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';

  var handle = function handle() {
    window.swan.webView[actionName]({
      url: url
    });
  };

  if (!window.swan) {
    _scriptHelper["default"].loadScript(CONSTS.baidu_SdkUrl, handle);
  } else {
    handle();
  }
};

var aliMiniNavigateTo = function aliMiniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';

  var handle = function handle() {
    if (_versionHelper["default"].cur$Version['>=']('7.0.00')) {
      if (url === ALI_MINI_PROGRAM_ROUTES.index || url === ALI_MINI_PROGRAM_ROUTES.orderList) {
        try {
          window.my.switchTab({
            url: url
          });
        } catch (error) {
          window.my[actionName]({
            url: url
          });
        }
      } else {
        window.my[actionName]({
          url: url
        });
      }
    } else {
      window.my[actionName]({
        url: url
      });
    }
  };

  if (!window.my) {
    _scriptHelper["default"].loadScript(CONSTS.ali_SdkUrl, handle);
  } else {
    handle();
  }
};

var douYinMiniNavigateTo = function douYinMiniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';

  var handle = function handle() {
    if (_versionHelper["default"].cur$Version['>=']('7.0.00')) {
      if (url === ALI_MINI_PROGRAM_ROUTES.index || url === ALI_MINI_PROGRAM_ROUTES.orderList) {
        try {
          window.tt.miniProgram.switchTab({
            url: url
          });
        } catch (error) {
          window.tt.miniProgram[actionName]({
            url: url
          });
        }
      } else {
        window.tt.miniProgram[actionName]({
          url: url
        });
      }
    } else {
      window.tt.miniProgram[actionName]({
        url: url
      });
    }
  };

  if (!window.tt) {
    _scriptHelper["default"].loadScript(CONSTS.douYin_SdkUrl, handle);
  } else {
    handle();
  }
};

var wxMiniNavigateTo = function wxMiniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';
  var callback = arguments.length > 2 ? arguments[2] : undefined;

  var handle = function handle() {
    if (callback) {
      callback();
    }

    if (_versionHelper["default"].cur$Version['>=']('7.0.00')) {
      if (url === MINI_PROGRAM_ROUTES.index || url === MINI_PROGRAM_ROUTES.orderList) {
        try {
          window.wx.miniProgram.switchTab({
            url: url
          });
        } catch (error) {
          window.wx.miniProgram[actionName]({
            url: url
          });
        }
      } else {
        window.wx.miniProgram[actionName]({
          url: url
        });
      }
    } else {
      window.wx.miniProgram[actionName]({
        url: url
      });
    }
  };

  if (!window.wx) {
    _scriptHelper["default"].loadScript(CONSTS.wx_SdkUrl, handle);
  } else {
    handle();
  }
};

var redBookMiniNavigateTo = function redBookMiniNavigateTo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MINI_PROGRAM_ROUTES.index;
  var actionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigateTo';
  var callback = arguments.length > 2 ? arguments[2] : undefined;

  var handle = function handle() {
    if (callback) {
      callback();
    }

    if (_versionHelper["default"].cur$Version['>=']('7.0.00')) {
      if (url === MINI_PROGRAM_ROUTES.index || url === MINI_PROGRAM_ROUTES.orderList) {
        try {
          window.xhs.miniProgram.switchTab({
            url: url
          });
        } catch (error) {
          window.xhs.miniProgram[actionName]({
            url: url
          });
        }
      } else {
        window.xhs.miniProgram[actionName]({
          url: url
        });
      }
    } else {
      window.xhs.miniProgram[actionName]({
        url: url
      });
    }
  };

  if (!window.xhs) {
    _scriptHelper["default"].loadScript(CONSTS.redBook_SdkUrl, handle);
  } else {
    handle();
  }
};

var hashRouterGetToken = function hashRouterGetToken(token) {
  var params = '';
  window.Mytoken = token;
  window.sessionStorage.setItem('tokenVal', token);
  var locationSarch = window.location.search;
  var pathname = window.location.pathname;

  if (window.location.hash) {
    locationSarch = window.location.hash;
    pathname = window.location.hash;
  }

  if (locationSarch.includes('?')) {
    if (locationSarch.includes('token=')) {
      var oldToken = '';
      var reg = new RegExp('(^|&)' + 'token' + '=([^&]*)(&|$)', 'i');
      var r = locationSarch.substr(1).match(reg);

      if (r !== null) {
        oldToken = unescape(decodeURI(r[2]));
      }

      params = locationSarch.replace(oldToken, '').replace('token=', 'token=' + token);
    } else {
      params = locationSarch + '&token=' + token;
    }
  } else {
    params = '?token=' + token;
  }

  var newUrl = window.location.hash ? window.location.origin + params : window.location.origin + pathname + params;
  window.location.replace(newUrl);
  window.location.reload();
};

var _getToken = function _getToken(token) {
  var params = '';
  window.Mytoken = token;
  window.sessionStorage.setItem('tokenVal', token);

  if (window.location.search) {
    if (window.location.search.includes('token=')) {
      var oldToken = '';
      var reg = new RegExp('(^|&)' + 'token' + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);

      if (r !== null) {
        oldToken = unescape(decodeURI(r[2]));
      }

      params = window.location.search.replace(oldToken, '').replace('token=', 'token=' + token);
    } else {
      params = window.location.search + '&token=' + token;
    }
  } else {
    params = '?token=' + token;
  }

  var newUrl = window.location.origin + window.location.pathname + params;
  window.location.replace(newUrl);
};

var goHelpBuyIndex = function goHelpBuyIndex() {
  var otherHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    location.href = CONSTS.downLoadAPPUrl;
  };

  if (_UA["default"].env.shanSongApp) {
    try {
      var hostname = window.location.hostname;
      var url = 'https://mai.ishansong.com';

      if (hostname.includes('astable')) {
        url = 'http://mai-astable.bingex.com';
      } else if (hostname.includes('bstable')) {
        url = 'http://mai-bstable.bingex.com';
      } else if (hostname.includes('cstable')) {
        url = 'http://mai-cstable.bingex.com';
      } else {
        url = 'https://mai.ishansong.com';
      }

      _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.routeTo, {
        url: url
      });
    } catch (error) {
      console.error(error.err || error);
      otherHandle();
    }
  } else if (_UA["default"].env.wxMiniProgram) {
    wxMiniNavigateTo(MINI_PROGRAM_ROUTES.helpBuyIndex);
  } else {
    otherHandle();
  }
};

var goBlackList = function goBlackList() {
  if (_UA["default"].env.shanSongApp) {
    _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.courierBlackList);
  } else if (_UA["default"].env.wxMiniProgram) {
    wxMiniNavigateTo(MINI_PROGRAM_ROUTES.blackList);
  } else if (_UA["default"].env.shanSong_redBookMini) {
    redBookMiniNavigateTo(MINI_PROGRAM_ROUTES.blackList);
  } else if (_UA["default"].env.alipay) {
    aliMiniNavigateTo(ALI_MINI_PROGRAM_ROUTES.blackList);
  } else if (_UA["default"].env.swanApp) {
    swanMiniNavigateTo(BAIDU_MINI_PROGRAM_ROUTES.blackList);
  } else if (_UA["default"].env.douYinMini) {
    douYinMiniNavigateTo(DOUYIN_MINI_PROGRAM_ROUTES.blackList);
  }
};

var goOrderList = function goOrderList() {
  if (_UA["default"].env.shanSong_userApp) {
    _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.orderList);
  } else if (_UA["default"].env.wxMiniProgram) {
    wxMiniNavigateTo(MINI_PROGRAM_ROUTES.orderList);
  } else if (_UA["default"].env.shanSong_redBookMini) {
    redBookMiniNavigateTo(MINI_PROGRAM_ROUTES.orderList);
  } else if (_UA["default"].env.alipay) {
    aliMiniNavigateTo(ALI_MINI_PROGRAM_ROUTES.orderList);
  } else if (_UA["default"].env.swanApp) {
    swanMiniNavigateTo(BAIDU_MINI_PROGRAM_ROUTES.orderList);
  } else if (_UA["default"].env.douYinMini) {
    douYinMiniNavigateTo(DOUYIN_MINI_PROGRAM_ROUTES.orderList);
  } else {
    location.href = location.pathname.includes('v2') ? '/v2/order' : '/order';
  }
};

var goLogin = function goLogin() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    registSource: '',
    routerIsHash: false
  };
  var routerIsHash = false;

  if (config instanceof Object) {
    routerIsHash = config.routerIsHash || false;
  } else {
    routerIsHash = !!config;
  }

  if (_UA["default"].env.shanSongApp) {
    window.getToken = routerIsHash ? hashRouterGetToken : _getToken;

    var registSource = _getRegsSourceVal(config);

    var source_id = _getSourceId(config);

    if (registSource) {
      var param = {
        registSource: _base64Helper["default"].toBase64(JSON.stringify({
          source_id: source_id,
          registSource: registSource
        }))
      };
      var paramEncoded = encodeURIComponent(JSON.stringify(param));
      window.location.href = NATIVE_PROTOCOL.fastLogin + paramEncoded;
    } else {
      window.location.href = NATIVE_PROTOCOL.fastLogin;
    }
  } else if (_UA["default"].env.wxMiniProgram) {
    wxMiniNavigateTo(_joinRegistSource(MINI_PROGRAM_ROUTES.login, config));
  } else if (_UA["default"].env.shanSong_redBookMini) {
    redBookMiniNavigateTo(_joinRegistSource(MINI_PROGRAM_ROUTES.login, config));
  } else if (_UA["default"].env.alipay) {
    aliMiniNavigateTo(_joinRegistSource(ALI_MINI_PROGRAM_ROUTES.login, config));
  } else if (_UA["default"].env.swanApp) {
    swanMiniNavigateTo(_joinRegistSource(BAIDU_MINI_PROGRAM_ROUTES.login, config));
  } else if (_UA["default"].env.douYinMini) {
    douYinMiniNavigateTo(_joinRegistSource(DOUYIN_MINI_PROGRAM_ROUTES.login, config));
  }
};

var _joinRegistSource = function _joinRegistSource() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var config = arguments.length > 1 ? arguments[1] : undefined;

  try {
    var registSource = _getRegsSourceVal(config);

    var source_id = _getSourceId(config);

    if (registSource) {
      return "".concat(url, "?registSource=").concat(registSource, "&source_id=").concat(source_id);
    } else {
      return url;
    }
  } catch (error) {
    return url;
  }
};

var _getRegsSourceVal = function _getRegsSourceVal() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(config instanceof Object)) {
    return '';
  }

  try {
    if (config.registSource) {
      return JSON.parse(config.registSource).registSource || '';
    } else {
      return '';
    }
  } catch (error) {
    console.error(error);
    return '';
  }
};

var _getSourceId = function _getSourceId() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(config instanceof Object)) {
    return '';
  }

  try {
    if (config.registSource) {
      return JSON.parse(config.registSource).source_id || '';
    } else {
      return '';
    }
  } catch (error) {
    console.error(error);
    return '';
  }
};

var miniPostMessage = function miniPostMessage(_ref) {
  var _ref$protocol = _ref.protocol,
      protocol = _ref$protocol === void 0 ? '' : _ref$protocol,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;

  if (_UA["default"].env.alipay) {
    my.postMessage(_objectSpread(_objectSpread({}, data), {}, {
      protocol: protocol
    }));
    return;
  }

  if (_UA["default"].env.swanApp) {
    swan.webView.postMessage({
      data: {
        protocol: protocol,
        data: data
      }
    });
    return;
  }

  if (_UA["default"].env.wxMiniProgram) {
    wx.miniProgram.postMessage({
      data: {
        protocol: protocol,
        data: data
      }
    });
    return;
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    xhs.miniProgram.postMessage({
      data: {
        data: {
          protocol: protocol,
          data: data
        }
      }
    });
    return;
  }

  if (_UA["default"].env.douYinMini) {
    tt.miniProgram.postMessage({
      data: {
        protocol: protocol,
        data: data
      }
    });
  }

  console.warn('miniPostMessage 不支持该容器环境，utils不支持');
};

var closePage = function closePage() {
  if (_UA["default"].env.issNewMobile) {
    window.history.back();
  } else if (_UA["default"].env.shanSongApp) {
    if (_UA["default"].env.shanSong_sellerApp) {
      try {
        _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.closePage);
      } catch (error) {
        alert(error);
      }
    } else {
      try {
        _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.closePage);
      } catch (error) {
        var data = {
          needClose: true
        };
        var dataEncoded = encodeURIComponent(JSON.stringify(data));
        window.location.href = NATIVE_PROTOCOL.certificate + dataEncoded;
      }
    }
  } else {
    if (_UA["default"].env.wxMiniProgram) {
      loadSDK(function () {
        var Wx = wx;
        Wx.miniProgram.navigateBack();
      });
    } else if (_UA["default"].env.shanSong_redBookMini) {
      loadSDK(function () {
        xhs.miniProgram.navigateBack();
      });
    } else if (_UA["default"].env.alipay) {
      loadSDK(function () {
        var My = my;
        My.navigateBack();
      });
    } else if (_UA["default"].env.douYinMini) {
      loadSDK(function () {
        var Tt = tt;
        Tt.miniProgram.navigateBack();
      });
    } else if (_UA["default"].env.swanApp) {
      loadSDK(function () {
        var SWAN = swan;
        SWAN.webView.navigateBack();
      });
    } else if (_UA["default"].env.hwquickApp) {
      loadSDK(function () {
        var QA = qa;
        QA.navigateBack({
          delta: 1
        });
      });
    } else {
      window.location.href = document.referrer;
    }
  }
};

var _goHelpBuyOrderDetail = function _goHelpBuyOrderDetail(_ref2) {
  var orderNumber = _ref2.orderNumber,
      _ref2$toast = _ref2.toast,
      toast = _ref2$toast === void 0 ? defaultToast : _ref2$toast;

  if (!orderNumber) {
    toast('订单号为空,请稍后再试');
    return;
  }

  if (_UA["default"].env.shanSongApp) {
    _this.versionName = getQueryString('versionName');
    _this.VERSION = '6.0.50';
    _this.maxVersion = _versionHelper["default"].versionCompare(_this.versionName || '', _this.VERSION);

    if (_this.maxVersion === "".concat(_this.VERSION, "\u7248\u672C\u9AD8")) {
      toast('请升级闪送APP至最新版本查看帮我买订单');
    } else {
      try {
        _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.buyDetail, {
          orderNumber: orderNumber
        });
      } catch (error) {
        toast(error.err || error);
      }
    }
  } else {
    if (_UA["default"].env.wxMiniProgram) {
      var url = '/pages/mai-order-detail/index?orderNumber=' + orderNumber;
      wx.miniProgram.navigateTo({
        url: url
      });
    } else {
      toast('请前往闪送APP查看帮我买订单');
    }
  }
};

var goOrderDetail = function goOrderDetail(_ref3) {
  var _ref3$isHelpBuyOrder = _ref3.isHelpBuyOrder,
      isHelpBuyOrder = _ref3$isHelpBuyOrder === void 0 ? false : _ref3$isHelpBuyOrder,
      _ref3$closeCurView = _ref3.closeCurView,
      closeCurView = _ref3$closeCurView === void 0 ? true : _ref3$closeCurView,
      orderNumber = _ref3.orderNumber,
      history = _ref3.history,
      _ref3$toast = _ref3.toast,
      toast = _ref3$toast === void 0 ? defaultToast : _ref3$toast,
      _ref3$h5Action = _ref3.h5Action,
      h5Action = _ref3$h5Action === void 0 ? null : _ref3$h5Action;

  if (!orderNumber) {
    toast('订单号为空,请稍后再试');
    return;
  }

  if (isHelpBuyOrder) {
    _goHelpBuyOrderDetail({
      orderNumber: orderNumber,
      toast: toast
    });
  } else {
    if (_UA["default"].env.shanSongApp) {
      var param = {
        orderNumber: orderNumber
      };

      if (!closeCurView && _UA["default"].env.shanSong_sellerApp) {
        param.transactionDetail = true;
      }

      var paramEncoded = encodeURIComponent(JSON.stringify(param));
      window.location.href = NATIVE_PROTOCOL.orderDetail + paramEncoded;
      return;
    }

    if (_UA["default"].env.hwquickApp) {
      window.location.href = 'hap://app/cn.ishansong.quick/pages/order-detail/order-detail?orderNumber=' + orderNumber;
      return;
    }

    var miniUrl = '/pages/order-detail/order-detail?orderNumber=' + orderNumber;

    if (_UA["default"].env.alipay) {
      aliMiniNavigateTo(miniUrl);
      return;
    }

    if (_UA["default"].env.swanApp) {
      swanMiniNavigateTo(miniUrl);
      return;
    }

    var miniUrl2 = '/pages/order-detail/index?orderNumber=' + orderNumber;

    if (_UA["default"].env.wxMiniProgram) {
      wxMiniNavigateTo(miniUrl2);
      return;
    }

    if (_UA["default"].env.shanSong_redBookMini) {
      redBookMiniNavigateTo(miniUrl2);
      return;
    }

    if (_UA["default"].env.douYinMini) {
      douYinMiniNavigateTo(miniUrl2);
      return;
    }

    if (h5Action) {
      h5Action();
    } else {
      toast('请下载闪送app');
    }
  }
};

var goRecharge = function goRecharge(_ref4) {
  var history = _ref4.history,
      _ref4$toast = _ref4.toast,
      toast = _ref4$toast === void 0 ? defaultToast : _ref4$toast;

  if (_UA["default"].env.shanSongApp) {
    return;
  }

  if (_UA["default"].env.swanApp) {
    swanMiniNavigateTo('/pages/wallet/wallet');
    return;
  }

  if (_UA["default"].env.wxMiniProgram) {
    miniNavigateTo('/pages/recharge/index');
    return;
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    redBookMiniNavigateTo('/pages/recharge/index');
    return;
  }

  if (_UA["default"].env.alipay || _UA["default"].env.hwquickApp || _UA["default"].env.douYinMini) {
    toast('如需充值请前往"闪送APP"操作');
    return;
  }

  if (history) {}
};

var _transParams = function _transParams(urlParams) {
  return urlParams.replace(/=/g, ':').replace(/&/g, ',');
};

var openWebview = function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(url) {
    var rule, urlParams, _rule, _urlParams, _rule2, _urlParams2, _rule3, _urlParams3;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_UA["default"].env.shanSongApp) {
              _context.next = 10;
              break;
            }

            if (!_UA["default"].env.shanSong_sellerApp) {
              _context.next = 7;
              break;
            }

            if (location.href.includes('h5Debug')) {
              if (!url.includes(location.search)) {
                if (url.includes('?')) {
                  url += '&' + location.search.slice(1, location.search.length);
                } else {
                  url += location.search;
                }
              }

              url = _urlHelper["default"].urlQueryJoin(url, 'ishansong', 'true');
              url = _urlHelper["default"].urlQueryJoin(url, 'h5Debug', 'true');

              try {
                _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.accountInfo);
              } catch (error) {
                window.open(url);
              }
            }

            _context.next = 5;
            return _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.openWebPage, {
              url: url
            });

          case 5:
            _context.next = 8;
            break;

          case 7:
            _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.routeTo, {
              url: url
            });

          case 8:
            _context.next = 11;
            break;

          case 10:
            if (_UA["default"].env.wxMiniProgram) {
              rule = /^(\/pages\/|pages\/)/;

              if (rule.test(url)) {
                wxMiniNavigateTo(url);
              } else {
                urlParams = url.split('?')[1];

                if (urlParams) {
                  urlParams = _transParams(url.split('?')[1]);
                  wxMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0], "&urlParams=").concat(urlParams));
                } else {
                  wxMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0]));
                }
              }
            } else if (_UA["default"].env.shanSong_redBookMini) {
              _rule = /^(\/pages\/|pages\/)/;

              if (_rule.test(url)) {
                redBookMiniNavigateTo(url);
              } else {
                _urlParams = url.split('?')[1];

                if (_urlParams) {
                  _urlParams = _transParams(url.split('?')[1]);
                  redBookMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0], "&urlParams=").concat(_urlParams));
                } else {
                  redBookMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0]));
                }
              }
            } else if (_UA["default"].env.douYinMini) {
              _rule2 = /^(\/pages\/|pages\/)/;

              if (_rule2.test(url)) {
                douYinMiniNavigateTo(url);
              } else {
                _urlParams2 = url.split('?')[1];

                if (_urlParams2) {
                  _urlParams2 = _transParams(url.split('?')[1]);
                  douYinMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0], "&urlParams=").concat(_urlParams2));
                } else {
                  douYinMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0]));
                }
              }
            } else if (_UA["default"].env.ali_mini) {
              _rule3 = /^(\/pages\/|pages\/)/;

              if (_rule3.test(url)) {
                aliMiniNavigateTo(url);
              } else {
                _urlParams3 = url.split('?')[1];

                if (_urlParams3) {
                  _urlParams3 = _transParams(url.split('?')[1]);
                  aliMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0], "&urlParams=").concat(_urlParams3));
                } else {
                  aliMiniNavigateTo("/pages/web-view/index?goUrl=".concat(url.split('?')[0]));
                }
              }
            } else {
              window.open(url);
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function openWebview(_x) {
    return _ref5.apply(this, arguments);
  };
}();

var _mergePositionData = function _mergePositionData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    return {
      lat: deepGet(data, 'latitude', '') || deepGet(data, 'data.lat', ''),
      lng: deepGet(data, 'longitude', '') || deepGet(data, 'data.lng', '')
    };
  } catch (error) {
    console.error(error);
    return {
      lat: '',
      lng: ''
    };
  }
};

var getPosition = function getPosition() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    Confirm: null,
    content: null
  };
  var Confirm = config.Confirm,
      content = config.content;
  return new Promise(function (resolve, reject) {
    try {
      if (_UA["default"].env.shanSong_sellerApp) {
        try {
          var res = _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.checkLocationPermission);

          if (res.data.isHavePermission) {
            _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.startLocation).then(function (positionData) {
              resolve(_mergePositionData(positionData));
            })["catch"](function (error) {
              reject(error.err || error);
            });
          } else {
            Confirm.confirm(content, (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
              return _regenerator["default"].wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.openAppSetting);

                    case 2:
                      _context2.t0 = resolve;
                      _context2.next = 5;
                      return getPosition();

                    case 5:
                      _context2.t1 = _context2.sent;
                      (0, _context2.t0)(_context2.t1);

                    case 7:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), {
              sure: '去设置',
              cancel: '取消'
            }, function () {
              if (_UA["default"].env.shopApp_hos) {
                reject(new Error('设置取消'));
              }
            });
          }
        } catch (error) {
          reject(error.err || error);
        }
      } else if (_UA["default"].env.shanSong_userApp) {
        try {
          var _res = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.checkLocationPermission);

          if (_res.data.isHavePermission) {
            _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.startLocation).then(function (positionData) {
              resolve(_mergePositionData(positionData));
            })["catch"](function (error) {
              reject(error.err || error);
            });
          } else {
            Confirm.confirm(content, (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3() {
              return _regenerator["default"].wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.openAppSetting);

                    case 2:
                      _context3.t0 = resolve;
                      _context3.next = 5;
                      return getPosition();

                    case 5:
                      _context3.t1 = _context3.sent;
                      (0, _context3.t0)(_context3.t1);

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })), {
              sure: '去设置',
              cancel: '取消'
            });
          }
        } catch (error) {
          reject(error.err || error);
        }
      } else if (_UA["default"].env.wxMiniProgram) {
        var _window2 = window,
            _wx = _window2.wx;

        if (_wx) {
          _wx.getLocation({
            type: 'gcj02',
            success: function success(res) {
              resolve(_mergePositionData(res));
            },
            cancel: function cancel(res) {
              reject(new Error('用户取消'));
            },
            fail: function fail(res) {
              console.info('ready getLocation fail=' + JSON.stringify(res));
              reject(new Error('出现故障，请联系管理员'));
            }
          });
        } else {
          reject(new Error('wxSDK初始化失败'));
        }
      } else {
        reject(new Error('不支持，请检查是否是微信小程序环境或者闪送app环境'));
      }
    } catch (error) {
      reject(error);
    }
  });
};

var initGlobalAppCallFunc = function initGlobalAppCallFunc() {
  var routerIsHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  window.getToken = routerIsHash ? hashRouterGetToken : _getToken;

  window.inviteSuccess = function (param) {
    console.log('端上分享成功回调', param);
    window.sessionStorage.setItem('isAppBackSucFlag', true);
    window.location.reload();
  };
};

var showHeaderBar = function showHeaderBar() {
  try {
    if (_UA["default"].env.shanSong_sellerApp) {
      _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.isShowHeadBar, {
        show: 1
      });
    } else if (_UA["default"].env.shanSongApp) {
      _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.webConfig, {
        hideNav: false
      });
    }
  } catch (error) {
    console.error('error', error);
  }
};

var hideHeaderBar = function hideHeaderBar() {
  try {
    if (_UA["default"].env.shanSong_sellerApp) {
      _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.isShowHeadBar, {
        show: 0
      });
    } else if (_UA["default"].env.shanSongApp) {
      _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.webConfig, {
        hideNav: true
      });
    }
  } catch (error) {
    console.error(error);
  }
};

var isIphoneX = function isIphoneX() {
  try {
    var appConfigData = {};

    if (_UA["default"].env.shanSong_userApp_ios) {
      appConfigData = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.appConfig);
    }

    if (_UA["default"].env.shanSong_sellerApp_ios) {
      appConfigData = _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.appConfig);
    }

    if (deepGet(appConfigData, 'data.iPhoneXSeries') === true) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

var toESongApp = function toESongApp() {
  window.location.href = 'iss://esong';
};

var _default = {
  NATIVE_PROTOCOL: NATIVE_PROTOCOL,
  toESongApp: toESongApp,
  isIphoneX: isIphoneX,
  showHeaderBar: showHeaderBar,
  hideHeaderBar: hideHeaderBar,
  wxConfigInit: wxConfigInit,
  goOrderList: goOrderList,
  initGlobalAppCallFunc: initGlobalAppCallFunc,
  redirectToIndex: redirectToIndex,
  getPosition: getPosition,
  openWebview: openWebview,
  webSdkInit: webSdkInit,
  miniPostMessage: miniPostMessage,
  closePage: closePage,
  goRecharge: goRecharge,
  goOrderDetail: goOrderDetail,
  goBlackList: goBlackList,
  goHelpBuyIndex: goHelpBuyIndex,
  MINI_PROGRAM_ROUTES: MINI_PROGRAM_ROUTES,
  goLogin: goLogin,
  goIndex: goIndex,
  callTel: callTel,
  miniNavigateTo: miniNavigateTo,
  wxMiniNavigateTo: wxMiniNavigateTo,
  swanMiniNavigateTo: swanMiniNavigateTo,
  aliMiniNavigateTo: aliMiniNavigateTo,
  douYinMiniNavigateTo: douYinMiniNavigateTo,
  redBookMiniNavigateTo: redBookMiniNavigateTo
};
exports["default"] = _default;